import React, { useContext } from "react";
import { ThemeContext } from "../theme";

function Footer() {
    const { colors } = useContext(ThemeContext)!;

    return (
        <footer className={`${colors.bgColor} border-t ${colors.borderColor} py-12 bg`}>
            <div className="container mx-auto px-6 max-w-6xl">
                {/* Top section: links */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-0 mb-10">
                    {/* Logo & description */}
                    <div>
                        <h2 className={`text-2xl font-bold ${colors.textColor}`}>I Call On</h2>
                        <p className={`${colors.textColor} opacity-70 mt-2 max-w-sm`}>
                            Fast-paced multiplayer word game. Challenge friends, test your vocabulary, and climb the leaderboard.
                        </p>
                    </div>

                    {/* Links */}
                    <div className="flex flex-col sm:flex-row gap-6">
                        <div className="flex flex-col gap-2">
                            <h3 className={`font-semibold ${colors.textColor}`}>Company</h3>
                            <a href="/" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Home</a>
                            <a href="/how-to-play" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>How to Play</a>
                            <a href="/about" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>About</a>
                            <a href="/faqs" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>FAQs</a>
                            <a href="/contact" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Contact</a>
                            <a href="/subscription" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Subscription</a>
                            <a href="/download" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Download App</a>
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className={`font-semibold ${colors.textColor}`}>Legal</h3>
                            <a href="/terms" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Terms & Conditions</a>
                            <a href="/privacy" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Privacy Policy</a>
                            <a href="/community-guidelines" className={`${colors.textColor} opacity-70 hover:opacity-100 transition`}>Community Guidelines</a>
                        </div>
                    </div>
                </div>

                {/* App download section */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mb-10">
                    <p className={`${colors.textColor} opacity-70`}>
                        Download the app:
                    </p>
                    <div className="flex gap-4">
                        <button onClick={() => window.open("https://play.google.com/store/apps/details?id=com.icallon", "_blank")}>
                            <img src={process.env.PUBLIC_URL + '/images/google-play-badge.png'} alt="Google Play" className="h-12" />
                        </button>
                        <button onClick={() => window.open("https://apps.apple.com/us/app/icallon/id6446251262", "_blank")}>
                            <img src={process.env.PUBLIC_URL + '/images/app-store-badge.png'} alt="App Store" className="h-12" />
                        </button>
                    </div>
                </div>

                {/* Bottom section: copyright */}
                <div className="text-center border-t border-gray-200 dark:border-neutral-800 pt-6">
                    <p className={`${colors.textColor} opacity-70 text-sm`}>
                        &copy; {new Date().getFullYear()} I Call On. All rights reserved.
                    </p>
                    <p className={`${colors.textColor} opacity-70 text-sm mt-1`}>
                        Built with ❤️ for word game lovers.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
